__turbopack_context__.v({
  "carouselThumb": "H6_6da_carouselThumb",
  "container": "H6_6da_container",
  "lineButton": "H6_6da_lineButton",
  "slide": "H6_6da_slide",
  "viewport": "H6_6da_viewport",
});
